// extracted by mini-css-extract-plugin
export default {"NavCol":"navtabs_NavCol__2zKvh","NavCard":"navtabs_NavCard__QWYIl","TabsList":"navtabs_TabsList__9c1dH","activeTab":"navtabs_activeTab__7M76k"};